import FieldTypesEnum from '../Enums/FieldTypesEnum';
import TpJobItem from './ThirdParty/TpJob/TpJobItem';

export default class ProjectTpJobItem extends TpJobItem {
  static FieldsToShowInDataTable() {
    return [
      {
        label: TpJobItem.getSelectedCellHeader,
        orderById: '',
        data: TpJobItem.getSelectedCellContent,
        minWidth: 20,
        rolekey: 'project_edit',
      },
      {
        label: 'ID',
        orderById: 'TpJobId',
        data: 'TpJobId',
        minWidth: 50,
        type: FieldTypesEnum.DataFieldWithDetails,
      },
      {
        label: 'Third-Party Job ID',
        orderById: 'ThirdPartyJobId',
        data: 'ThirdPartyJobId',
        minWidth: 50,
      },
      {
        label: 'Source',
        orderById: 'ThirdPartySource',
        data: 'ThirdPartySource',
        minWidth: 50,
      },
      {
        // This is always empty for now
        label: 'Invoice',
        orderById: 'Invoice',
        data: 'Invoice',
        minWidth: 50,
      },
      {
        label: 'Location',
        orderById: 'ThirdPartyLocationName',
        data: 'ThirdPartyLocationName',
        minWidth: 50,
      },
      {
        label: 'Fieldwork Office',
        orderById: 'FieldworkOfficeName',
        data: 'FieldworkOfficeName',
        minWidth: 50,
      },
      {
        label: 'Evaluator',
        orderById: 'EvaluatorName',
        data: 'EvaluatorName',
        minWidth: 50,
      },
      {
        label: 'Status',
        orderById: 'ThirdPartyJobStatus',
        data: 'ThirdPartyJobStatus',
        minWidth: 50,
      },
      {
        label: 'Completed On',
        orderById: 'JobDate',
        data: 'JobDate',
        minWidth: 50,
      },
      {
        label: 'Country',
        orderById: 'ThirdPartyLocationCountry',
        data: 'ThirdPartyLocationCountry',
        minWidth: 50,
      },
      {
        label: 'Uninvoiceable',
        orderById: 'Uninvoiceable',
        data: 'Uninvoiceable',
        minWidth: 20,
      },
    ];
  }
}
